import { ComponentProps } from 'react';

import * as SwitchPrimitive from '@radix-ui/react-switch';

import { cn } from '@/utils/tailwind.ts';

type SwitchProps = ComponentProps<typeof SwitchPrimitive.Root>;

const Switch = ({ className, ...props }: SwitchProps) => {
  return (
    <SwitchPrimitive.Root
      data-slot="switch"
      className={cn(
        'w-[44px] h-[24px] cursor-pointer data-[state=checked]:!bg-custom-cyan-400 data-[state=unchecked]:bg-custom-warm-grey-200 inline-flex shrink-0 items-center rounded-full transition-all border-none outline-none hover:!bg-custom-warm-grey-300',
        className
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb
        data-slot="switch-thumb"
        className={cn(
          'bg-white pointer-events-none block size-5 rounded-full shadow-sm transition-transform data-[state=checked]:translate-x-[calc(100%+2px)] data-[state=unchecked]:translate-x-[2px]'
        )}
      />
    </SwitchPrimitive.Root>
  );
};

export { Switch };
